/**
 * ISO 3166-1 alpha-2 country codes for sanctioned countries.
 * Airports in these countries are excluded from airport search (frontend filter).
 */
export const SANCTIONED_COUNTRY_CODES = [
  'CU', // Cuba
  'IR', // Iran
  'SY', // Syria
  'KP', // North Korea
];

/**
 * Returns true if the airport record belongs to a sanctioned country (should be excluded).
 * @param {Object} airport - Airport object from API (may have address.country_code, country_code, country_id)
 * @returns {boolean}
 */
export function isSanctionedCountry(airport) {
  if (!airport) return true;
  const code = (
    (airport.address && airport.address.country_code) ||
    airport.country_code ||
    airport.country_id ||
    ''
  ).toUpperCase();
  if (!code) return false; // unknown country: allow (don't block)
  return SANCTIONED_COUNTRY_CODES.includes(code);
}

/**
 * Filter out airports in sanctioned countries.
 * @param {Array} airports - Raw array from airport-search API
 * @returns {Array}
 */
export function filterSanctionedAirports(airports) {
  if (!Array.isArray(airports)) return [];
  return airports.filter((a) => !isSanctionedCountry(a));
}
